import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { api, ApiError } from '../lib/api';
import { useAuth, type Persona } from '../lib/auth';

/** Lands here from the gateway's One Citizen callback with a one-time code. */
export function SignInComplete() {
  const [params] = useSearchParams();
  const { completeLogin } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const exchanged = useRef(false);

  useEffect(() => {
    if (exchanged.current) return;
    exchanged.current = true;
    const code = params.get('code');
    if (!code) {
      setError('Missing sign-in code.');
      return;
    }
    api
      .post<{ token: string; persona: Persona }>('/auth/onecitizen/exchange', { code })
      .then((r) => {
        completeLogin(r.token, r.persona);
        navigate('/inbox', { replace: true });
      })
      .catch((e: unknown) => {
        setError(e instanceof ApiError ? e.message : 'Sign-in could not be completed.');
      });
  }, [params, completeLogin, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-ink-950">
      <div className="text-center">
        {error ? (
          <>
            <p className="text-sm text-rose-400">{error}</p>
            <a href="/" className="mt-3 inline-block text-sm font-semibold text-brand-100 underline">
              Back to sign-in
            </a>
          </>
        ) : (
          <>
            <span className="mx-auto block h-8 w-8 animate-spin rounded-full border-2 border-ink-700 border-t-white" />
            <p className="mt-3 text-sm text-slate-400">Completing One Citizen sign-in…</p>
          </>
        )}
      </div>
    </div>
  );
}
